var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10345 6.10345C7.10345 3.83718 8.94062 2 11.2069 2C13.4732 2 15.3103 3.83718 15.3103 6.10345C15.3103 8.36972 13.4732 10.2069 11.2069 10.2069C8.94062 10.2069 7.10345 8.36972 7.10345 6.10345ZM11.2069 0C7.83606 0 5.10345 2.73261 5.10345 6.10345C5.10345 9.47429 7.83606 12.2069 11.2069 12.2069C14.5777 12.2069 17.3103 9.47429 17.3103 6.10345C17.3103 2.73261 14.5777 0 11.2069 0ZM6.10345 15.3103C4.48471 15.3103 2.93228 15.9534 1.78766 17.098C0.64304 18.2426 0 19.7951 0 21.4138V23.9655C0 24.5178 0.447715 24.9655 1 24.9655C1.55228 24.9655 2 24.5178 2 23.9655V21.4138C2 20.3255 2.43233 19.2818 3.20187 18.5122C3.97142 17.7427 5.01515 17.3103 6.10345 17.3103H16.3103C17.3986 17.3103 18.4424 17.7427 19.2119 18.5122C19.9815 19.2818 20.4138 20.3255 20.4138 21.4138V23.9655C20.4138 24.5178 20.8615 24.9655 21.4138 24.9655C21.9661 24.9655 22.4138 24.5178 22.4138 23.9655V21.4138C22.4138 19.7951 21.7708 18.2426 20.6261 17.098C19.4815 15.9534 17.9291 15.3103 16.3103 15.3103H6.10345Z",
    fill: "#122B87"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.14ffd61a2811fadbfcc8aa9ba90ac276.svg";
export { ForwardRef as ReactComponent };